import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-privilege',
  templateUrl: './delete-privilege.component.html',
  styleUrls: ['./delete-privilege.component.css']
})
export class DeletePrivilegeComponent implements OnInit {

  privilege:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  deleteId:any = [];

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllPrivileges()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllPrivileges();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllPrivileges();
  }
 
 


  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }
 
  
  getAllPrivileges(){
    this.generic_service.getAllPrivileges().subscribe(
      (response:any)=>{
        this.privilege = response.response;
        console.log(response)
      }
    )
  }
 
 
  deletePriviilege(){
    this.generic_service.deletePriviilege(this.deleteId).subscribe(
    (res:any)=>{
      console.log(res)
      this.toastr.success("Successfully deleted");
      this.getAllPrivileges();
      this.cancelModel();
    },err=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
    }
    )
  }

  del(id:any){
  this.deleteId = id
  }

}
